import { render, staticRenderFns } from "./ListManagement.template.vue?vue&type=template&id=2ba76950&scoped=true&"
var script = {}
import style0 from "./ListManagement.template.vue?vue&type=style&index=0&id=2ba76950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba76950",
  null
  
)

export default component.exports